import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { chulaVistaConfig } from "./data";

export default function ChulaVistaPage() {
  return <CityPageTemplate config={chulaVistaConfig} />;
}